export default __webpack_public_path__ + "static/media/students_1.645b0ce1.jpg";